import { atom } from 'recoil';

export interface Annotation {
  title: string;
  position: {
    x: number;
    y: number;
    z: number;
  };
  lookAt: {
    x: number;
    y: number;
    z: number;
  };
  cameraUp: {
    x: number;
    y: number;
    z: number;
  },
  idx: number;
};

export const annotationState = atom<Annotation>({
  key: 'annotationState',
  default: {
    title: 'default',
    position: {
      x: 0,
      y: -3,
      z: 2,
    },
    lookAt: {
      x: 0,
      y: 0,
      z: 0,
    },
    cameraUp: {
      x: 0,
      y: 0,
      z: 1
    },
    idx: 0,
  }
});

export const rotationCWState = atom<number>({
  key: 'rotationCWState',
  default: 0
});

export const rotationCCWState = atom<number>({
  key: 'rotationCCWState',
  default: 0
});

export const downloadSnapshotState = atom<number>({
  key: 'downloadSnapshotState',
  default: 0
});

export const isVisibleDesignSpaceState = atom<boolean>({
  key: 'isVisibleDesignSpaceState',
  default: true
});

export const isVisibleModelState = atom<boolean>({
  key: 'isVisibleModelState',
  default: true
});

export const isVisibleCocoonState = atom<boolean>({
  key: 'isVisibleCocoonState',
  default: true
});

export const isVisibleTireState = atom<boolean>({
  key: 'isVisibleTireState',
  default: false
});

export const isVisibleWheelhouseState = atom<boolean>({
  key: 'isVisibleWheelhouseState',
  default: false
});

export const isVisibleMorphedState = atom<boolean>({
  key: 'isVisibleMorphedState',
  default: true
});

export const isVisibleMorphingBoxState = atom<boolean>({
  key: 'isVisibleMorphingBoxState',
  default: true
});
